// TODO: Redo this entire system when links are introduced
// TODO
class FetchTransport {
    async doRequest(operation, key, input) {
        if (operation === "subscription" || operation === "subscriptionStop") {
            throw new Error(`Subscribing to '${key}' failed as the HTTP transport does not support subscriptions! Maybe try using the websocket transport?`);
        }
        let method = "GET";
        let body = undefined;
        let headers = new Headers();
        const params = new URLSearchParams();
        if (operation === "query") {
            if (input !== undefined) {
                params.append("input", JSON.stringify(input));
            }
        } else if (operation === "mutation") {
            method = "POST";
            body = JSON.stringify(input || {});
            headers.set("Content-Type", "application/json");
        }
        const paramsStr = params.toString();
        const resp = await this.fetch(`${this.url}/${key}${paramsStr.length > 0 ? `?${paramsStr}` : ""}`, {
            method,
            body,
            headers
        });
        const respBody = await resp.json();
        const { type , data  } = respBody.result;
        if (type === "error") {
            const { code , message  } = data;
            throw new RSPCError(code, message);
        }
        return data;
    }
    constructor(url, fetch){
        this.url = url;
        this.fetch = fetch || globalThis.fetch.bind(globalThis);
    }
}
const randomId = ()=>Math.random().toString(36).slice(2);
const timeouts = [
    1000,
    2000,
    5000,
    10000
]; // In milliseconds
class WebsocketTransport {
    attachEventListeners() {
        this.ws.addEventListener("message", (event)=>{
            const { id , result  } = JSON.parse(event.data);
            if (result.type === "event") {
                if (this.clientSubscriptionCallback) this.clientSubscriptionCallback(id, result.data);
            } else if (result.type === "response") {
                if (this.requestMap.has(id)) {
                    this.requestMap.get(id)?.({
                        type: "response",
                        result: result.data
                    });
                    this.requestMap.delete(id);
                }
            } else if (result.type === "error") {
                const { message , code  } = result.data;
                if (this.requestMap.has(id)) {
                    this.requestMap.get(id)?.({
                        type: "error",
                        message,
                        code
                    });
                    this.requestMap.delete(id);
                }
            } else {
                console.error(`Received event of unknown type '${result.type}'`);
            }
        });
        this.ws.addEventListener("close", (event)=>{
            this.reconnect();
        });
    }
    async reconnect(timeoutIndex = 0) {
        let timeout = // @ts-expect-error // TODO: Fix this
        (timeouts[timeoutIndex] ?? timeouts[timeouts.length - 1]) + (Math.floor(Math.random() * 5000 /* 5 Seconds */ ) + 1);
        setTimeout(()=>{
            let ws = new WebSocket(this.url);
            new Promise(function(resolve, reject) {
                ws.addEventListener("open", ()=>resolve(null));
                ws.addEventListener("close", reject);
            }).then(()=>{
                this.ws = ws;
                this.attachEventListeners();
            }).catch((err)=>this.reconnect(timeoutIndex++));
        }, timeout);
    }
    async doRequest(operation, key, input, opts) {
        if (this.ws.readyState == 0) {
            let resolve;
            const promise = new Promise((res)=>{
                resolve = ()=>res(undefined);
            });
            // @ts-ignore
            this.ws.addEventListener("open", resolve);
            await promise;
        }
        const id = randomId();
        let resolve;
        const promise = new Promise((res)=>{
            resolve = res;
        });
        // @ts-ignore
        this.requestMap.set(id, resolve);
        this.ws.send(JSON.stringify({
            id,
            method: operation,
            params: {
                path: key,
                input
            }
        }));
        const body = await promise;
        if (body.type === "error") {
            const { code , message  } = body;
            throw new RSPCError(code, message);
        } else if (body.type === "response") {
            return body.result;
        } else {
            throw new Error(`RSPC Websocket doRequest received invalid body type '${body?.type}'`);
        }
    }
    constructor(url){
        this.requestMap = new Map();
        this.url = url;
        this.ws = new WebSocket(url);
        this.attachEventListeners();
    }
}
// TODO
class NoOpTransport {
    async doRequest(operation, key, input) {
        return new Promise(()=>{});
    }
    constructor(){}
}

// TODO
function createClient(args) {
    return new Client(args);
}
// TODO
class Client {
    async query(keyAndInput) {
        try {
            return await this.transport.doRequest("query", keyAndInput[0], keyAndInput[1]);
        } catch (err) {
            if (this.onError) {
                this.onError(err);
            }
            throw err;
        }
    }
    async mutation(keyAndInput) {
        try {
            return await this.transport.doRequest("mutation", keyAndInput[0], keyAndInput[1]);
        } catch (err) {
            if (this.onError) {
                this.onError(err);
            }
            throw err;
        }
    }
    // TODO: Redesign this, i'm sure it probably has race conditions but it works for now
    addSubscription(keyAndInput, opts) {
        try {
            let subscriptionId = randomId();
            let unsubscribed = false;
            const cleanup = ()=>{
                this.subscriptionMap?.delete(subscriptionId);
                if (subscriptionId) {
                    this.transport.doRequest("subscriptionStop", undefined, subscriptionId);
                }
            };
            this.transport.doRequest("subscription", keyAndInput[0], [
                subscriptionId,
                keyAndInput[1]
            ]);
            if (opts.onStarted) opts.onStarted();
            this.subscriptionMap?.set(subscriptionId, opts.onData);
            return ()=>{
                unsubscribed = true;
                cleanup();
            };
        } catch (err) {
            if (this.onError) {
                this.onError(err);
            }
            return ()=>{};
        }
    }
    constructor(args){
        this._rspc_def = undefined;
        this.subscriptionMap = new Map();
        this.transport = args.transport;
        this.transport.clientSubscriptionCallback = (id, value)=>{
            const func = this.subscriptionMap?.get(id);
            if (func !== undefined) func(value);
        };
        this.subscriptionMap = new Map();
        this.onError = args.onError;
    }
}

class RSPCError {
    constructor(code, message){
        this.code = code;
        this.message = message;
    }
}

export { Client, FetchTransport, NoOpTransport, RSPCError, WebsocketTransport, createClient, randomId };
